import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div ref={ref} className="relative w-full max-w-md">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3 text-sm text-foreground-800 transition-colors hover:border-background-300"
      >
        <span className="flex items-center gap-2">
          <i className="ri-grid-line text-base text-primary-600"></i>
          <span className="font-medium">{t("drop.label")}</span>
        </span>
        <i className={`ri-arrow-down-s-line text-base text-foreground-500 transition-transform ${open ? "rotate-180" : ""}`}></i>
      </button>

      {open && (
        <div className="absolute inset-x-0 top-full z-30 mt-2 max-h-80 overflow-auto rounded-lg border border-background-200 bg-background-50 py-1">
          {categories.map((c) => (
            <a
              key={c.id}
              href={c.url}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setOpen(false)}
              className="flex items-center justify-between whitespace-nowrap px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
            >
              <span>{t(`cat.${c.id}`)}</span>
              <i className="ri-arrow-right-up-line text-sm text-foreground-400"></i>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}